import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './FeatureList.scss';
import Feature from '../Feature';

export interface FeatureListProps extends WithTranslation {
  productIndex: number;
}

class FeatureList extends React.Component<FeatureListProps> {
  renderFeature = (id: number) => (
    <Feature
      key={id}
      description={`highlights.features.${this.props.productIndex}.${id}`}
    />
  );

  render() {
    return (
      <div className={s.root} data-hook="featureList">
        {this.renderFeature(0)}
        {this.renderFeature(1)}
        {this.renderFeature(2)}
      </div>
    );
  }
}

export default withTranslation()(FeatureList);
